import { render, staticRenderFns } from "./Sortierung.vue?vue&type=template&id=e9871b74&scoped=true"
import script from "./Sortierung.vue?vue&type=script&lang=js"
export * from "./Sortierung.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e9871b74",
  null
  
)

export default component.exports